(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anatomy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.anatomy').forEach((root) => {
    const spots = root.querySelectorAll('.hotspot');
    const close = () => spots.forEach((s) => s.setAttribute('aria-expanded', 'false'));
    spots.forEach((s) => s.addEventListener('click', (e) => { e.stopPropagation(); const open = s.getAttribute('aria-expanded') === 'true'; close(); s.setAttribute('aria-expanded', String(!open)); }));
    document.addEventListener('click', close);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ctabs]').forEach((root) => {
    root.querySelectorAll('[data-ctab]').forEach((b) => b.addEventListener('click', () => {
      const i = b.dataset.ctab;
      root.querySelectorAll('[data-ctab]').forEach((x) => x.setAttribute('aria-selected', x === b));
      root.querySelectorAll('[data-ctab-panel]').forEach((p) => { p.hidden = p.dataset.ctabPanel !== i; });
      root.querySelectorAll('[data-ctab-desc]').forEach((p) => { p.hidden = p.dataset.ctabDesc !== i; });
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-rotate]').forEach((hero) => {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.setAttribute('aria-current', k === i)); };
    let t = setInterval(() => show(i + 1), parseInt(hero.dataset.heroRotate, 10) || 6000);
    dots.forEach((d) => d.addEventListener('click', () => { clearInterval(t); show(parseInt(d.dataset.heroDot, 10)); t = setInterval(() => show(i + 1), parseInt(hero.dataset.heroRotate, 10) || 6000); }));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) clearInterval(t);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.Diara = window.Diara || {};
  // description: at most 3 lines, cut on a word with "… Read more" inline at the cut (designer round 3)
  document.querySelectorAll('[data-desc-short]').forEach((p) => {
    const span = p.querySelector('[data-desc-text]'), full = p.querySelector('[data-desc-full]').textContent.trim(), btn = p.querySelector('[data-desc-toggle]');
    const rest = p.closest('.pdp__desc').querySelector('[data-desc-rest]');
    let open = false;
    const fit = () => {
      if (open) return;
      span.textContent = full; btn.hidden = false;
      const lh = parseFloat(getComputedStyle(p).lineHeight) || 24, max = lh * 3 + 2;
      if (p.offsetHeight <= max) { btn.hidden = !p.dataset.hasRest; return; }
      const words = full.split(/\s+/); let lo = 1, hi = words.length, best = 1;
      while (lo <= hi) { const mid = (lo + hi) >> 1; span.textContent = words.slice(0, mid).join(' ') + '…'; if (p.offsetHeight <= max) { best = mid; lo = mid + 1; } else hi = mid - 1; }
      span.textContent = words.slice(0, best).join(' ').replace(/[,;:.]$/, '') + '…';
    };
    btn.addEventListener('click', () => { open = true; span.textContent = full; if (rest) rest.hidden = false; btn.remove(); });
    fit(); let t; addEventListener('resize', () => { clearTimeout(t); t = setTimeout(fit, 120); });
    if (document.fonts) document.fonts.ready.then(fit);
  });
  (() => {
    const bar = document.querySelector('[data-sticky-bar]'), inline = document.querySelector('[data-inline-form]');
    if (!bar) return;
    if (!inline || !('IntersectionObserver' in window)) { bar.classList.add('is-shown'); return; }
    new IntersectionObserver(([en]) => { bar.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top < 0); }).observe(inline);
  })();
  const track = document.querySelector('[data-featured-media]');
  const slides = () => [...track.querySelectorAll('[data-media-id]')];
  const thumbs = [...document.querySelectorAll('.pdp__thumb')];
  const order = slides().map((el) => el.dataset.mediaId);
  const setActive = (id) => thumbs.forEach((t) => t.classList.toggle('is-active', String(t.dataset.thumbFor) === String(id)));
  const goTo = (id, smooth = true) => {
    let el = track.querySelector(`[data-media-id="${id}"]`);
    if (!el && order.includes('cutout')) el = track.querySelector('[data-media-id="cutout"]');  // e.g. the Large variant's image is the hero render that the cut-out replaces
    if (!el) return;
    track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActive(el.dataset.mediaId);
  };
  const showMedia = (id, fromUser) => {
    if (!fromUser && order.includes('cutout')) return;  // initial variant sync keeps the cut-out hero on load
    goTo(id);
    if (fromUser) { const th = document.querySelector(`.pdp__thumb[data-thumb-for="${id}"]`); th && th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
  };
  window.Diara.mediaSwitch = (id, fromUser) => showMedia(id, !!fromUser);
  thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumbFor, true)));
  const currentIndex = () => { const w = track.clientWidth || 1; return Math.max(0, Math.min(order.length - 1, Math.round(track.scrollLeft / w))); };
  const stepMedia = (n) => showMedia(order[(currentIndex() + n + order.length) % order.length], true);
  let scrollTimer;
  track.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(() => { const id = order[currentIndex()]; setActive(id); const th = document.querySelector(`.pdp__thumb[data-thumb-for="${id}"]`); th && th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }, 80); }, { passive: true });
  if (order.length > 1) {
    document.querySelectorAll('[data-media-prev]').forEach((b) => { b.hidden = false; b.addEventListener('click', () => stepMedia(-1)); });
    document.querySelectorAll('[data-media-next]').forEach((b) => { b.hidden = false; b.addEventListener('click', () => stepMedia(1)); });
    // mouse drag on desktop (touch uses native scroll-snap); a real drag suppresses the lightbox click
    let x0 = null, left0 = 0, dragged = false;
    track.addEventListener('dragstart', (e) => e.preventDefault());  // native image drag would hijack the mouse
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; x0 = e.clientX; left0 = track.scrollLeft; dragged = false; });
    window.addEventListener('pointermove', (e) => { if (x0 === null) return; const dx = e.clientX - x0; if (!dragged && Math.abs(dx) > 6) { dragged = true; track.classList.add('is-dragging'); } if (dragged) track.scrollLeft = left0 - dx; });
    let lastX = null;
    window.addEventListener('pointermove', (e) => { if (x0 !== null) lastX = e.clientX; });
    const endDrag = () => {
      if (x0 === null) return;
      const dx = (lastX === null ? x0 : lastX) - x0; const start = Math.round(left0 / (track.clientWidth || 1));
      x0 = null; lastX = null;
      if (!dragged) return;
      track.classList.remove('is-dragging');
      const target = dx < -60 ? start + 1 : dx > 60 ? start - 1 : start;  // a short drag settles back, a real one moves one slide
      requestAnimationFrame(() => goTo(order[Math.max(0, Math.min(order.length - 1, target))]));
    };
    window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') stepMedia(1); if (e.key === 'ArrowLeft') stepMedia(-1); });
    track.tabIndex = 0;
  }

  } catch(e) { console.error(e); }
})();
})();
